module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Reference periods"},"de":{"label":"Referenzperioden"}}')
  delete Component.options._Ctor
}
